import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IRawApplication } from 'projects/common/src/app/interfaces/remote-models/raw-application';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { UserDataService } from 'src/app/modules/core/services/parameter';
import { IWidgetSendConfiguration } from '../../interfaces/widget-send-configuration';
import { WidgetConfigurationService } from '../../services/widget-configuration.service';

@Component({
  selector: 'app-widget-configuration-modal',
  templateUrl: './widget-configuration-modal.component.html',
  styleUrls: ['./widget-configuration-modal.component.scss']
})
export class WidgetConfigurationModalComponent implements OnInit {

  @Input()
  public widget: IRawApplication;

  @Input()
  public instanceRef: any;

  public widgetForm: FormGroup;

  public isEnabledOptions: { name: string, value: boolean }[];

  public numberArray: { name: string, value: number }[];

  public classNumbers: { name: string, value: number }[];

  public changeStatus: string;

  public isLoading: boolean;

  private currentClass: string;

  constructor(
    private formBuilder: FormBuilder,
    private langService: LanguageService,
    private activeModal: NgbActiveModal,
    private userService: UserDataService,
    private widgetConfigurationService: WidgetConfigurationService
  ) {
    this.isEnabledOptions = [
      { name: this.langService.message('yes'), value: true },
      { name: this.langService.message('no'), value: false }
    ];

    this.numberArray = [];
    this.classNumbers = [];
    this.isLoading = false;
  }

  /**
   * Init app
   */
  ngOnInit() {
    this.createForm();

    for (let i = 0; i <= 15; i ++) {
      this.numberArray.push({ name: String(i), value: i });
    }

    for (let i = 1; i <= 12; i ++) {
      this.classNumbers.push({ name: String(i), value: i });
    }
  }

  /**
   * Function to create form
   */
  private createForm(): void {
    
    const classLg = Number(this.getClass().replace('col-lg-', ''));
    this.currentClass = this.getClass();

    this.widgetForm = this.formBuilder.group({
      visibleName: [this.widget.visibleName, Validators.required],
      orderElement: [this.widget.orderElement, Validators.required],
      description: [this.widget.description, Validators.required],
      timeout: [this.widget.timeout, Validators.required],
      delay: [this.widget.delay, Validators.required],
      class: [classLg, Validators.required],
      isEnabled: [this.widget.isEnabled, Validators.required]
    });
  }

  /**
   * Function to close modal
   */
  public closeModal(): void {
    this.activeModal.dismiss();
  }

  /**
   * Function to change configuration by form inputs
   */
  public changeConfiguration(): void {

    this.isLoading = true;

    const orderElement = this.getForm('orderElement').value ? this.getForm('orderElement').value : this.getForm('orderElement');
    const isEnabled = typeof this.getForm('isEnabled').value === 'boolean' ? this.getForm('isEnabled').value : this.getForm('isEnabled');

    const classLg = this.getForm('class').value ? this.getForm('class').value : this.getForm('class');
    const classHTML = this.widget.class.replace(this.currentClass, `col-lg-${classLg}`);
    

    const newConfig: IWidgetSendConfiguration = {
      class: classHTML,
      componentId: this.widget.componentId,
      description: this.getForm('description'),
      isEnabled,
      orderElement,
      timeout: Number(this.getForm('timeout')),
      delay: Number(this.getForm('delay')),
      visibleName: this.getForm('visibleName'),
      userId: this.userService.get().id
    };

    this.widgetConfigurationService.changeConfiguration(newConfig, this.instanceRef).then((status) => {
      this.changeStatus = status;
    }).finally(() => {
      this.isLoading = false;
      setTimeout(() => this.changeStatus = null, 5000);
    });
  }

  /**
   * Function to get control value
   * @param key form control key
   */
  public  getForm(key: string): any {
    if ((key === 'isEnabled' && !this.widgetForm.controls.isEnabled.value) ||
      (key === 'orderElement' && !this.widgetForm.controls.orderElement.value)) {
      return this.widgetForm.controls[key];
    }

    return this.widgetForm.controls[key].value;
  }

  /**
   * Function to get if form has errors
   */
  public get hasError(): boolean {
    return Boolean(
      this.widgetForm.controls.visibleName.errors ||
      this.widgetForm.controls.orderElement.errors ||
      this.widgetForm.controls.description.errors ||
      this.widgetForm.controls.timeout.errors ||
      this.widgetForm.controls.delay.errors ||
      this.widgetForm.controls.class.errors ||
      this.widgetForm.controls.isEnabled.errors
    );
  }

  /**
   * Function to get 'col-lg-X' class from widget class
   */
  private getClass(): string {
    const cols = [];
    for (let i = 1; i < 13; i ++) {
      cols.push(`col-lg-${i}`);
    }

    const splitted = this.widget.class.split(' ');

    for (const split of splitted) {
      for (const col of cols) {
        if (split === col) {
          return col;
        }
      }
    }
  }
}
